enum Gender {
    none = "",
    female = "f",
    male = "m"
}

export default Gender;